import React, { FC } from 'react';
import { application, PropsOfRoute } from '@/routes';

const Application: FC<PropsOfRoute<typeof application>> = (): JSX.Element => <div />;

export default Application;
